'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  landingPageEvent,
  InfluencerLandingPageModel,
  InfluencerLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { IntroductionSection } from './components/IntroductionSection'
import { LifestyleSection } from './components/LifestyleSection/LifestyleSection'
import { TipsSection } from './components/TipsSection/TipsSection'
import { ClosetSection } from './components/ClosetSection/ClosetSection'
import { InspirationSection } from './components/InspirationSection'

type Props = {
  content: InfluencerLandingPageModel
}

const TheWardrobeEdit = ({ content }: Props) => {
  const { track } = useTracking()

  useEffect(() => {
    const trackLandingPageView = async () =>
      track(
        landingPageEvent({
          event: InfluencerLandingPageEvent.PageView,
          referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
          deviceId: await getFingerprint(),
        }),
      )

    trackLandingPageView()
  }, [track])

  return (
    <div className="influencer-landing-page grid12">
      <IntroductionSection data={content.introduction} />
      <LifestyleSection data={content.lifestyle} />
      <ClosetSection data={content.closet} />
      <TipsSection data={content.tips} />
      <InspirationSection data={content.inspiration} />
    </div>
  )
}

export default TheWardrobeEdit
